import './404.scss';
import './img/wheel.png';
import './img/car_wheel.svg';

$(document).ready(function() {
  let flexFont = function () {
    let divs = document.getElementsByClassName("logo-404__number");
    for(let i = 0; i < divs.length; i++) {
      let relFontsize = divs[i].offsetWidth*1.5;
      divs[i].style.fontSize = relFontsize+'px';
    }
  };

  $(window).on('load resize', function() {
    flexFont();
  });
});

